import { defineMessages } from 'react-intl';

export default defineMessages({
  numPolice: {
    id: 'amc_details.my_contracts.num_police',
  },
  nomPolice: {
    id: 'amc.details.organisme.name',
  },
  identification: {
    id: 'amc_details.my_contracts.identification',
  },
  paymentChoice: {
    id: 'amc_details.my_contracts.payment_choice',
  },
  rib: {
    id: 'amc_details.my_contracts.rib',
  },
  mandateAddress: {
    id: 'amc_details.my_contracts.mandate_address',
  },
  adresse: {
    id: 'amc_details.my_refunds.address',
  },
  type: {
    id: 'amc.details.type',
  },
  name: {
    id: 'amc.details.name',
  },
});
